import {SelectOptionsType} from 'global';
import {useGetAllBoardsByWorkSpaceSlug} from 'hooks/board';
import React, {useEffect, useMemo} from 'react';
import {AppControlledAutoCompleteProps, AppControlledAutoComplete} from './AutoComplete';

interface AppBoardSelectProps extends Omit<AppControlledAutoCompleteProps, 'options' | 'value'> {
    workspaceSlug: string;
}

export const AppBoardSelect: React.FC<AppBoardSelectProps> = ({workspaceSlug, ...props}) => {
    const {getAllBoards, getAllBoardsLoading, getAllBoardsResponse} = useGetAllBoardsByWorkSpaceSlug();

    useEffect(() => {
        getAllBoards(workspaceSlug);
    }, [workspaceSlug]);

    const statusOptions: SelectOptionsType[] = useMemo(() => {
        if (!getAllBoardsLoading && getAllBoardsResponse) {
            return getAllBoardsResponse.map(x => ({
                label: x.title,
                value: x.slug,
            }));
        }
        return [];
    }, [getAllBoardsLoading, getAllBoardsResponse]);

    return <AppControlledAutoComplete loading={getAllBoardsLoading} options={statusOptions} {...props} />;
};

export default AppBoardSelect;
